export function toDate(date: string) {
  return date ? new Date(date).toLocaleString().replace(",", "") : ""; // Leading zeros for mm and dd
}
export function timeFormat(time: number) {}

export function extractDate(date: Date) {
  return date.toISOString().split("T")[0];
}
